export const CUEPOINT = "CUEPOINT";
export const HOTSPOT = "HOTSPOT";
